import App from '@/App';
import BuildRevision from '@/components/BuildRevision';
import ResponsiveToaster from '@/components/ResponsiveToaster';
import EventListeners from '@/components/common/EventListeners';
import { persistor, store } from '@/state/store';
import history from '@/utils/history';
import '@fontsource/roboto';
import ReactDOM from 'react-dom/client';
import { Provider as ReduxProvider } from 'react-redux';
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';

import { SWROptions } from '@/config/swr';
import { SWRConfig } from 'swr';

import '@/styles/index.css';
import '@/styles/onboarding-animations.css';
import '@/styles/react-datepicker.css';
import '@/styles/react-loading-skeleton.css';
import '@/styles/react-mosaic-component.css';
import '@/styles/scrollbar.css';

import { MantineProvider, createTheme } from '@mantine/core';
import { BalancesProvider } from './utils/providers/BalancesProvider';
import { LuceraProvider } from './utils/providers/LuceraProvider';
import { MarketDataProvider } from './utils/providers/MarketDataProvider';
import { OhoProvider } from './utils/providers/OhoProvider';
import { PositionsProvider } from './utils/providers/PositionsProvider';
import { SSOProvider } from './utils/providers/SSOProvider';
import { ScreenSizesProvider } from './utils/providers/ScreenSizesProvider';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const theme = createTheme({});

root.render(
    <SWRConfig value={SWROptions}>
        <ReduxProvider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <HistoryRouter history={history}>
                    <MantineProvider theme={theme}>
                        <OhoProvider>
                            <SSOProvider>
                                <LuceraProvider>
                                    <MarketDataProvider>
                                        <BalancesProvider>
                                            <PositionsProvider>
                                                <ScreenSizesProvider>
                                                    <App />
                                                    <EventListeners />
                                                    <ResponsiveToaster />
                                                    <BuildRevision />
                                                </ScreenSizesProvider>
                                            </PositionsProvider>
                                        </BalancesProvider>
                                    </MarketDataProvider>
                                </LuceraProvider>
                            </SSOProvider>
                        </OhoProvider>
                    </MantineProvider>
                </HistoryRouter>
            </PersistGate>
        </ReduxProvider>
    </SWRConfig>
);
